__webpack_require__.p = "https://dev-assets.panoee.com/tour/_next/";